export default "__VITE_ASSET__824fe29e__"